import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import axios from 'axios';
import apiClient from "../../api/apiClient";


function Home2() {
  const [contact, setContact] = useState([]);

  useEffect(() => {
    apiClient.get('api/contact/3/')

    .then((response) => setContact(response.data))
    .catch((error) => console.error(error));
}, []);

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            I turn ideas into clean, scalable software — no fluff, just results. I started coding as a hobby, but it quickly became second nature. Now, I build full-stack web apps, custom tools, and tech solutions that solve real problems. 🤷‍♂️
              <br />
              <br />I'm proficient in these languages
              <i>
                <b className="purple"> Python, Bash, Javascript and Go. </b>
              </i>
              <br />
              <br />
              My fields of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Applications and Software Solutions</b> and
                also in areas related to{" "}
                <b className="purple">
                  Artificial Intelligence, Blockchain.
                </b>
              </i>
              <br />
              <br />
            I primarily use Django as a backend Framework for my applications, as for the UI, I make use of
               <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js</b>
                         
              </i>
              <br />
              <br />
              Whether you're launching a startup, automating a workflow, or building something experimental — I'm the kind of dev who can make it real.

Let’s build something cool.

            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href={contact.github}
                  onClick={() => contact.github}

                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a 
                  href={contact.twitter}
                  onClick={() => contact.twitter}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href={contact.linkedin}
                  onClick={() => contact.linkedin}

                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href={contact.instagram}
                onClick={() => contact.instagram}

                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
